import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dqyt7n2k58: FaireBrandEntity = {
  token: "b_dqyt7n2k58",
  type: "brand",
  name: "Little Gypsy Farms",
  avatarUrl:
    "https://cdn.faire.com/fastly/71fb5addfebd0ec2494ed513a41376738554649b900e53d8d62963dc5a81bc56.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8b57573f12f2c4c83483225ceadd3360c0cc9ef3a071ea81bf61af159e3cc793.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/71fb5addfebd0ec2494ed513a41376738554649b900e53d8d62963dc5a81bc56.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8b57573f12f2c4c83483225ceadd3360c0cc9ef3a071ea81bf61af159e3cc793.jpeg",
  location: "MANASQUAN, NJ, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 19,
  isTopShop: true,
  isInsider: true,
  description:
    "Our family, whose surname translates to ‘Little Gypsy’, has always been a resourceful tribe. Cast out by invading Ottomans from outlying islands in search of safety and sustenance, our ancestors took to the mountains, fulfilling their namesake without a home, eventually settling on fertile ground alongside the Mediterranean Sea.\n\n​This seaside land between mountains in the southern Peloponnese of Greece provided an advantageous microclimate, always a few degrees warmer in the winter with more rainfall courtesy of the nearby peaks. Here we began to grow.​\n\nSettling our roots in the region for three generations cultivating ancient tree varieties, our farms continue the tradition of handpicking high quality/low yielding artisanal olives, cold pressing them into premium oil at the local mill within 24 hours. \n\nThe result is a nutritionally superior Extra Virgin Oil, higher in amino acids and polyphenol content yet low in acidity with a delicate flavor and a full nutty, artichoke finish.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:30.653Z",
    importedBy: "entity-db-cli",
  },
};
